/* eslint-disable react-hooks/exhaustive-deps */

import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';

import MonthlyCommunicateTo from '../../../../../components/MonthlyCommunicateTo/MonthlyCommunicateTo';
import { CommunicateToPermissions } from '../../../../../components/MonthlyServiceRequest/RequestDetailTypes';
import {
  DetailRequestMonthly,
  DetailRequestMonthlyDefaultProp
} from '../../../../../utils/globalPropTypes';

const MonthlyCommunicateToContainer = ({ details, communicateToPermissions, isOyM }) => {
  const initialValues = {
    communicate: {
      receivers: [],
      adicionalReceivers: [],
      isOyM: false
    }
  };

  return (
    <Formik initialValues={initialValues}>
      {() => (
        <Form>
          <MonthlyCommunicateTo
            communicateToPermissions={communicateToPermissions}
            details={details}
            isOyM={isOyM}
          />
        </Form>
      )}
    </Formik>
  );
};

MonthlyCommunicateToContainer.propTypes = {
  communicateToPermissions: CommunicateToPermissions,
  details: DetailRequestMonthly,
  isOyM: PropTypes.bool.isRequired
};
MonthlyCommunicateToContainer.defaultProps = {
  communicateToPermissions: {
    visualize: false,
    write: false
  },
  details: DetailRequestMonthlyDefaultProp
};

export default MonthlyCommunicateToContainer;
